import { createElement } from "react";
import type { AppRoute } from "@routes/types";
import AppShellLayout from "@components/ui/layout/AppShellLayout";
import type { RouteObject } from "react-router-dom";
import { TECHNICAL_ASSESSMENT_PATH } from "@routes/path";
import AssesmentPage from "@pages/technical-assesment";

const routes: AppRoute[] = [
    {
        path: TECHNICAL_ASSESSMENT_PATH,
        element: createElement(AssesmentPage),
        label: "Assessment",
    },
];

const TechnicalAssessmentRoute: RouteObject[] = [{
                element: createElement(AppShellLayout),
                children: routes
            }];

export default TechnicalAssessmentRoute;